import { render } from "./ChatMessageFile.vue?vue&type=template&id=4d86e9a3&scoped=true"
import script from "./ChatMessageFile.vue?vue&type=script&lang=js"
export * from "./ChatMessageFile.vue?vue&type=script&lang=js"

import "./ChatMessageFile.vue?vue&type=style&index=0&id=4d86e9a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d86e9a3"]])

export default __exports__